import { matchPath } from 'react-router-dom'
import { getIsBulkOrderEnabled } from '../../common/bulkOrder'
import links from '../app/links'

const BULK_ORDER_PATHS = [
  { path: links.BULK_ORDER, end: true },
  { path: links.BULK_ORDER_CART, end: true },
  { path: links.BULK_ORDERS, end: true },
  { path: links.BULK_ORDER_DETAIL, end: true },
]

export const isBulkOrderRelatedPath = pathname =>
  Boolean(pathname && BULK_ORDER_PATHS.some(pattern => matchPath(pattern, pathname)))

export const getHeaderOrdersLink = (pathname, viewer, hostConf) => {
  if (getIsBulkOrderEnabled(viewer, hostConf) && isBulkOrderRelatedPath(pathname)) {
    return links.BULK_ORDERS
  }
  return links.HOME
}
